var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['w-empty-state-cell', { left: _vm.leftAlign, reset: _vm.reset }],attrs:{"tabindex":"0"}},[_c('CommonIcon',{attrs:{"id":"minus-solid","color":"#c5cee0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }